import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { onSessionExpired } from '@/lib/api/sessionExpiry'
import { clearSession } from '@/lib/auth/session'

import { buildLoginPath } from './returnTo'

/**
 * 세션 만료의 **유일한 반응 지점**(설계 불변식 4).
 * navigation 에 의존하므로 `RouterProvider` 안쪽(RootLayout)에 둔다.
 *
 * 정리 항목은 자발적 로그아웃과 **같은 구현**(`clearSession`)을 쓴다 — 두 경로가 갈라지면
 * 한쪽만 캐시를 비우는 식으로 어긋난다(설계 A2).
 */
export function RootLayout() {
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()

  // 구독은 한 번만 걸고, 만료 시점의 "현재 경로"는 ref 로 읽는다.
  // location 을 deps 에 넣으면 이동마다 구독을 재설치하게 된다.
  const locationRef = useRef(location)
  locationRef.current = location

  useEffect(() => {
    return onSessionExpired(() => {
      clearSession(queryClient)
      const current = locationRef.current
      // 만료는 비자발적이므로 돌아올 곳을 남긴다(로그아웃과 다른 점).
      navigate(buildLoginPath(`${current.pathname}${current.search}`), { replace: true })
    })
  }, [navigate, queryClient])

  return <Outlet />
}
